(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-hover-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  if (window.__cardHoverGallery) return;
  window.__cardHoverGallery = true;

  var GRID = '#ProductGridContainer';
  var CARD = '[data-hg-card]';
  var BTN = 34;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var parsedCache = new WeakMap();
  var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 120); };
  var ICON = {
    prev: '<svg viewBox="0 0 20 20" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12.5 4.5 7 10l5.5 5.5"/></svg>',
    next: '<svg viewBox="0 0 20 20" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M7.5 4.5 13 10l-5.5 5.5"/></svg>'
  };

  function handleOf(link) {
    var match = (link.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
    if (!match) return null;
    try { return decodeURIComponent(match[1]); } catch (e) { return match[1]; }
  }

  /* The card is the largest element around the picture that still holds one product only.
     Only used when the grid loads or refreshes, never while hovering. */
  function cardOf(link, grid) {
    var handle = handleOf(link);
    if (!handle) return null;
    var card = link;
    while (card.parentElement && card.parentElement !== grid) {
      var parent = card.parentElement;
      var others = parent.querySelectorAll('a[href*="/products/"]');
      var mixed = false;
      for (var i = 0; i < others.length; i++) {
        if (handleOf(others[i]) !== handle) { mixed = true; break; }
      }
      if (mixed) break;
      card = parent;
    }
    return card;
  }

  /* Any spot inside the card counts, not only the picture. */
  function cardAt(node) {
    return node && node.closest ? node.closest(CARD) : null;
  }

  function readData(grid) {
    var script = grid.querySelector('script[data-hover-gallery]');
    if (!script) return null;
    if (!parsedCache.has(script)) {
      var data = {};
      try { data = JSON.parse(script.textContent); } catch (e) { data = {}; }
      parsedCache.set(script, { data: data, prev: script.getAttribute('data-label-prev'), next: script.getAttribute('data-label-next') });
    }
    return parsedCache.get(script);
  }

  function makeButton(dir, text) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'hg-btn';
    button.setAttribute('data-hg-dir', dir);
    button.setAttribute('aria-label', text);
    button.innerHTML = ICON[dir];
    return button;
  }

  /* Corner radius of the nearest rounded ancestor (the card), softened for the inner picture. */
  function radiusFor(link, card) {
    var node = link.parentElement;
    while (node && node !== document.body) {
      var r = parseFloat(window.getComputedStyle(node).borderTopLeftRadius);
      if (r > 0) return Math.max(12, Math.min(28, Math.round(r * 0.7)));
      if (node === card) break;
      node = node.parentElement;
    }
    return 20;
  }

  function ensureImage(state, index, eager) {
    if (index === 0 || state.images[index]) return state.images[index];
    var entry = state.list[index];
    var el = document.createElement('img');
    el.alt = '';
    el.decoding = 'async';
    el.draggable = false;
    el.loading = eager ? 'eager' : 'lazy';
    el.sizes = state.sizes;
    el.srcset = entry.srcset;
    el.src = entry.src;
    state.frame.appendChild(el);
    state.images[index] = el;
    return el;
  }

  /* Runs when the grid appears or refreshes: puts the second picture into each card, hidden.
     Nothing is created on hover. */
  function setup(card, link, info, list) {
    var grid = card.closest(GRID);
    card._hg = null;

    /* Clear leftovers if the card was copied together with its hover parts. */
    Array.prototype.forEach.call(card.querySelectorAll('.hg-frame, .hg-btn'), function (el) { el.remove(); });

    var firstImg = link.querySelector('img');
    var frame = document.createElement('span');
    frame.className = 'hg-frame';
    frame.setAttribute('aria-hidden', 'true');
    link.classList.add('hg-link');
    link.appendChild(frame);

    var state = {
      card: card,
      img: firstImg,
      shown: firstImg.closest('picture') || firstImg,
      link: link,
      frame: frame,
      list: list,
      images: [],
      index: 0,
      token: 0,
      ready: false,
      dirty: true,
      hover: false,
      info: info,
      sizes: (firstImg.sizes || '') || '400px'
    };
    ensureImage(state, 1, false);
    card._hg = state;
    card.setAttribute('data-hg-card', '');
    if (watcher) watcher.observe(card);
    return state;
  }

  /* Once per card, a little before it scrolls into view: measure it, add the arrows,
     lift the sale tag above the picture. Hovering later is then just a swap. */
  function prepare(state) {
    if (state.ready) return;
    state.ready = true;
    var card = state.card, link = state.link;

    var host = link.offsetParent;
    if (!host || host === document.body || host === document.documentElement || !card.contains(host)) {
      host = card;
      if (window.getComputedStyle(card).position === 'static') card.style.position = 'relative';
    }
    state.host = host;
    if (window.getComputedStyle(link).position === 'static') link.style.position = 'relative';
    state.frame.style.setProperty('--hg-radius', radiusFor(link, card) + 'px');

    var width = state.img.getBoundingClientRect().width;
    if (width) state.sizes = Math.round(width) + 'px';

    state.prev = makeButton('prev', state.info.prev || 'Previous image');
    state.next = makeButton('next', state.info.next || 'Next image');
    /* Right after the picture link, so Tab reaches the arrows straight after the picture. */
    link.insertAdjacentElement('afterend', state.prev);
    state.prev.insertAdjacentElement('afterend', state.next);

    /* Badges and other absolutely placed bits stay above the hover picture. */
    Array.prototype.forEach.call(card.querySelectorAll('*'), function (el) {
      if (state.frame.contains(el) || el === state.prev || el === state.next || el === state.frame) return;
      var cs = window.getComputedStyle(el);
      if (cs.position !== 'absolute') return;
      var z = parseInt(cs.zIndex, 10);
      if (isNaN(z) || z < 6) el.style.zIndex = '6';
    });

    if ('ResizeObserver' in window) {
      var last = null;
      new ResizeObserver(function (entries) {
        var box = entries[0].contentRect;
        var key = Math.round(box.width) + 'x' + Math.round(box.height);
        if (last !== null && last !== key) state.dirty = true;
        last = key;
      }).observe(state.img);
    }
    place(state);
  }

  /* Frame sits on the card picture, with a little room above it. */
  function place(state) {
    state.dirty = false;
    var cs = window.getComputedStyle(state.link);
    var gap = parseFloat(cs.getPropertyValue('--hg-gap')) || 16;
    var link = state.link.getBoundingClientRect();
    var img = state.img.getBoundingClientRect();
    if (!img.width || !img.height) img = link;
    var inset = Math.min(gap, img.height * 0.2);
    var frame = state.frame.style;
    frame.top = (img.top - link.top - state.link.clientTop + inset) + 'px';
    frame.left = (img.left - link.left - state.link.clientLeft) + 'px';
    frame.width = img.width + 'px';
    frame.height = (img.height - inset) + 'px';

    var host = state.host.getBoundingClientRect();
    var fr = state.frame.getBoundingClientRect();
    var top = fr.top - host.top - state.host.clientTop + fr.height / 2 - BTN / 2;
    var left = fr.left - host.left - state.host.clientLeft;
    state.prev.style.top = state.next.style.top = top + 'px';
    state.prev.style.left = (left + 8) + 'px';
    state.next.style.left = (left + fr.width - 8 - BTN) + 'px';
  }

  /* Instant swap, like Horizon (no animation). */
  function apply(state, index) {
    state.images.forEach(function (el, i) { if (el) el.classList.toggle('hg-on', i === index); });
    state.frame.classList.toggle('hg-on', index > 0);
    state.shown.style.opacity = index > 0 ? '0' : '';
  }

  function show(state, index) {
    state.index = index;
    var token = ++state.token;
    if (index === 0) { apply(state, 0); return; }

    var el = ensureImage(state, index, true);
    el.loading = 'eager';
    var done = function () { if (state.token === token) apply(state, index); };
    if (el.complete && el.naturalWidth) done();
    else { el.addEventListener('load', done, { once: true }); el.addEventListener('error', done, { once: true }); }

    /* Warm up the neighbours so the arrows feel instant. */
    ensureImage(state, (index + 1) % state.list.length, true);
    ensureImage(state, (index - 1 + state.list.length) % state.list.length, true);
  }

  function activate(card) {
    var state = card._hg;
    if (!state) return null;
    prepare(state);
    if (state.dirty) place(state);
    card.classList.add('hg-active');
    return state;
  }

  document.addEventListener('pointerover', function (event) {
    if (event.pointerType !== 'mouse' || !fine.matches) return;
    var card = cardAt(event.target);
    if (!card || !card._hg || card._hg.hover) return;
    card._hg.hover = true;
    activate(card);
    show(card._hg, 1);
  });

  document.addEventListener('pointerout', function (event) {
    if (event.pointerType !== 'mouse') return;
    var card = cardAt(event.target);
    if (!card || !card._hg || !card._hg.hover) return;
    if (event.relatedTarget instanceof Node && card.contains(event.relatedTarget)) return;
    var state = card._hg;
    state.hover = false;
    if (!card.querySelector(':focus-visible')) card.classList.remove('hg-active');
    show(state, 0);
  });

  /* Keyboard: the arrows show whenever something inside the card has focus. */
  document.addEventListener('focusin', function (event) {
    if (!fine.matches) return;
    var card = cardAt(event.target);
    if (card && card._hg) activate(card);
  });

  document.addEventListener('focusout', function (event) {
    var card = cardAt(event.target);
    if (!card || (event.relatedTarget instanceof Node && card.contains(event.relatedTarget))) return;
    if (!card._hg || !card._hg.hover) card.classList.remove('hg-active');
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('[data-hg-dir]') : null;
    if (!button) return;
    var card = cardAt(button);
    var state = card && card._hg;
    if (!state) return;
    event.preventDefault();
    event.stopPropagation();
    var step = button.getAttribute('data-hg-dir') === 'next' ? 1 : -1;
    show(state, (state.index + step + state.list.length) % state.list.length);
  });

  /* Gets each card ready shortly before it scrolls into view. */
  var watcher = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      watcher.unobserve(entry.target);
      var state = entry.target._hg;
      if (state) idle(function () { if (state.card.isConnected) prepare(state); });
    });
  }, { rootMargin: '300px' }) : null;

  /* Prepare every card on load and again whenever filters or sorting refresh the grid. */
  function scan() {
    if (!fine.matches) return;
    Array.prototype.forEach.call(document.querySelectorAll(GRID), function (grid) {
      var info = readData(grid);
      if (!info) return;
      Array.prototype.forEach.call(grid.querySelectorAll('a[href*="/products/"]'), function (link) {
        if (link._hgSeen || !link.querySelector('img')) return;
        link._hgSeen = true;
        var existing = link.closest(CARD);
        if (existing && existing._hg) return;
        var handle = handleOf(link);
        var list = handle && info.data[handle];
        if (!list || list.length < 2) return;
        var card = cardOf(link, grid);
        if (card && card._hg === undefined) setup(card, link, info, list);
      });
    });
  }

  var queued = false;
  function queueScan() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; scan(); }, 150);
  }

  if (fine.matches) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', queueScan);
    else queueScan();
    window.addEventListener('load', queueScan);
    /* Only grid changes matter, everything else on the page is ignored. */
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        if (!added.length) continue;
        var target = mutations[i].target;
        if (!target.closest || (!target.closest(GRID) && !target.querySelector(GRID))) continue;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType === 1 && node.tagName !== 'IMG' && node.tagName !== 'BUTTON' && !node.classList.contains('hg-frame')) { queueScan(); return; }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
  } catch(e) { console.error(e); }
})();

})();
